import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import EnvironmentManager from 'Utils/environmentManager';
import Modal from 'Components/Modal';
import { toast } from 'react-toastify';
import ToastTemplate from 'Components/ToastTemplate';
import Icon from 'Components/Icon';
import Contract from 'Components/Modal/Contract';
import { updateUserDetails, getOccupations, saveInformationsOccupation, getUserAgreement, toggleOccupationPopup } from 'Store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { withMixpanel } from 'Utils/mixpanel';


const OccupationModal = ({ mixpanel }) => {
  const dispatch = useDispatch();
  const [occupations, setOccupations] = useState([]);
  const [filteredOccupation, setFilteredOccupation] = useState([]);
  const [query, setQuery] = useState('');
  const [selectedOccupationId, setSelectedOccupationId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(null);

  const auth = useSelector(state => state.auth);
  const userAgreement = useSelector(state => state.membership.userAgreement);
  const showOccupation = useSelector(state => state.drawer?.showOccupationPopup);

  const onInputChange = e => {
    setQuery(e.target.value);
  };

  const occupation_popup_text = EnvironmentManager.getMessageText({ key: 'occupation_popup_text' });
  const legalText1 = EnvironmentManager.getMessageText({ key: 'occupation_popup_legal_text_1' }) || 'Bilyoner Üyelik Aydınlatma Metni\'ne buradan ulaşabilirsiniz.';
  const legalText2 = EnvironmentManager.getMessageText({ key: 'occupation_popup_legal_text_2' }) || 'buradan';
  const occupation_popup_search_hint = EnvironmentManager.getMessageText({ key: 'occupation_popup_search_hint' });
  const occupation_popup_title = EnvironmentManager.getMessageText({ key: 'occupation_popup_title' });
  const normalizedLegalText2 = legalText2?.toLowerCase();
  const regex = new RegExp(`(${legalText2})`, 'gi');
  const highlightedLegalText = legalText1
    ?.split(regex)
    .map((part, index) =>
      part?.toLowerCase() === normalizedLegalText2 ? (
        <b key={ index } onClick={ () => {
          dispatch(getUserAgreement());
          setShowAgreementModal(true);
        } }>
          { part }
        </b>
      ) : (
        part
      )
    );

  useEffect(() => {
    if (query?.length > 0) {
      setFilteredOccupation(occupations?.filter(item => item?.occupationName?.toLocaleLowerCase('tr').includes(query?.toLocaleLowerCase('tr'))));
    } else {
      setFilteredOccupation(occupations);
    }

  }, [query, occupations]);

  useEffect(() => {
    if (showOccupation || auth.data.showOccupationPopUp) {
      getOccupations().then(res => {
        setOccupations(res?.data?.occupations);
      });
    }
    setShowModal(auth.data.showOccupationPopUp || showOccupation);
  }, [auth.data.showOccupationPopUp, showOccupation]);

  useEffect(()=> {
    if (auth?.data?.occupationName === null) {
      const parentNode = document.body;
      const observer = new MutationObserver(mutationsList => {
        mutationsList?.forEach(mutation => {
          mutation?.removedNodes.forEach(node => {
            if (node.nodeType === 1 && node.classList.contains('nationality-modal_occupation')) {
              if (!auth?.data?.occupationName) {
                document.body.appendChild(node);
              }
            }
          });
        });
      });
      if (showModal) {
        observer.observe(parentNode, { childList: true, subtree: true });
      } else observer.disconnect();

      return () => observer.disconnect();
    }
  }, [showModal, auth?.data?.occupationName]);

  useEffect(() => {
    if (showModal) {
      mixpanel.track('Occupation Modal Opened', {
        occupationName: auth?.data?.occupationName,
        showOccupationPopUp: auth?.data.showOccupationPopUp,
        showOccupation: showOccupation
      });
    }
  }, [showModal]);

  if (showAgreementModal) return <Modal
    disableOverlayClick
    onClose={ ()=> {
      const modalContent = document.querySelector('.blyn-drawer__content-inner');
      modalContent.scrollTop = 0;
      setShowAgreementModal(false);
    } }
    title='Bilyoner Üyelik Aydınlatma Metni'
  >
    <Contract>
      { userAgreement.isLoading ? ('Yükleniyor...') : userAgreement.data.content }
    </Contract>
  </Modal>;

  if (showModal) return <Modal
    className="nationality-modal_occupation"
    closeOnOutsideClick={ false }
    closeIconVisible={ EnvironmentManager.getMessageText({ key: 'occupation_popup_close_button' }) === 'true' }
    disableOverlayClick={ EnvironmentManager.getMessageText({ key: 'occupation_popup_close_button' }) === 'false' }
    onClose={ () => setShowModal(false) }
    buttonArea={ {
      primaryButton: {
        onClick: () => {
          if (selectedOccupationId) {
            saveInformationsOccupation({ occupationId: selectedOccupationId }).then(() => {
              dispatch(toggleOccupationPopup(false));
              dispatch(updateUserDetails(true));
              toast(
                <ToastTemplate type="success">
                  { EnvironmentManager.getMessageText({ key: 'occupation_popup_toast_message' }) }
                </ToastTemplate>,
                { toastId: 'maxBetReachedErrorToast' });

              setTimeout(()=>{
                if (window?.location?.pathname?.includes('sans-oyunlari')) {
                  window?.location?.reload();
                }
              }, 1000);
            });
          }
        },
        label: EnvironmentManager.getMessageText({ key: 'occupation_popup_button' }),
        disabled: !selectedOccupationId,
      },
    } }
  >
    <div className='home-nationality'>
      <div className='home-nationality-title'>{ occupation_popup_title }</div>
      <p className='home-nationality-content' dangerouslySetInnerHTML={ { __html: occupation_popup_text } }/>
      <p className="home-nationality-legal-text"> { highlightedLegalText }</p><p/>
      <Icon iconName='svgSearch'/>
      <div className="search-area">
        <input
          type="text"
          placeholder={ occupation_popup_search_hint }
          value={ query }
          onChange={ onInputChange }
          className={ `search-input ${query?.length > 0 ? 'has-text' : ''}` }
        />
        { query?.length > 0 && (
          <button onClick={ () => setQuery('') } className="clear-search-btn">
            Vazgeç
          </button>
        ) }
      </div>

    </div>

    <div className="home-nationality-body">
      { filteredOccupation.length > 0 ? (
        <ul className="list">
          { filteredOccupation.map(occupation => (
            <li
              key={ occupation?.id }
              className={ `item ${
                selectedOccupationId === occupation.id ? 'selected' : ''
              }` }
              onClick={ () => setSelectedOccupationId(occupation.id) }
            >
              { selectedOccupationId === occupation.id && (
                <Icon iconName="svgCheckGreen"/>
              ) }
              { occupation.occupationName }
            </li>
          )) }
        </ul>
      ) : (
        <p className="no-results">Hiçbir sonuç bulunamadı.</p>
      ) }
    </div>
  </Modal>;

  return <div />;

};

OccupationModal.propTypes = {
  mixpanel: PropTypes.object,
};

export default withMixpanel(OccupationModal);
